import React, { useState, useEffect } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import DataTable from "../../../components/Content/DataTable";
import DateFilterTable from "../../../components/Content/DateFilterTable";

// Date & Time
import moment from "moment";

import { getAlert, getData, getDataWithComp } from "../../../../utils/SamuiUtils";

function Main({
  masterList,
  detailList,
  statusColours,
  name,
  onPageInsert,
  onRowSelected,
  getReport,
}) {
  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(
    localStorage.getItem("itemsPerPageDropdown") || 10
  );
  const [countWaitPay, setCountWaitPay] = useState(0);
  const [countPaid, setCountPaid] = useState(0);
  const [countCancel, setCountCancel] = useState(0);

  // ใช้สำหรับค้นหาเอกสาร
  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem("searchTerm") || ""
  );
  const [filteredItems, setFilteredItems] = useState([]);

  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem("startDate");
    return storedStartDate || moment().startOf("month").format("YYYY-MM-DD");
  });
  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem("endDate");
    return storedEndDate || moment().endOf("month").format("YYYY-MM-DD");
  });
  const [dateType, setDateType] = useState("1");

  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    initialize();
  }, [masterList]);

  useEffect(() => {
    setCurrentPage(1);
    filterItems();
  }, [searchTerm, dataMasterList, selectedStatus]);

  useEffect(() => {
    filterItems();
  }, [startDate, endDate, searchTerm, masterList, selectedStatus]);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);

        const image = await getDataWithComp(
          "Upload_File_List",
          `AND DocCode_ID IN (4)`
        );

        const updatedMasterList = await Promise.all(masterList.map(async (item) => {
          const relatedFiles = image.filter(
            (img) => img.Doc_ID === item.Pay_Id
          );

          let relatedFilesRec = [];

          // เช็กว่าเป็นใบสำคัญจ่าย ที่จ่ายตามใบรับสินค้า
          if (Number(item.Pay_Type) === 1) {

            // ทำการเข้าไปเลขของใบรับไปค้นหาไฟล์ว่าเจอไหม
            const getDetailForRec = await getData("PAY_D", `Pay_Id = ${item.Pay_Id}`);
            if (getDetailForRec && getDetailForRec.length > 0) {
              const imageRec = await getDataWithComp(
                "Upload_File_List",
                `AND DocCode_ID = 3 AND Doc_ID = ${getDetailForRec[0].Rec_Id}`
              );
              relatedFilesRec = imageRec;
            }
          }

          return {
            ...item,
            File_Name: relatedFiles,
            File_Name_Rec: relatedFilesRec, // เอาไฟล์ของใบรับ ส่งเข้าไปด้วยเลย ไอคอนคลิปจะได้ไม่หาย
          };
        }));

        setFilteredItems(updatedMasterList);

        let statusCounts = {
          รอจ่าย: 0,
          จ่ายแล้ว: 0,
          ยกเลิก: 0,
        };

        masterList.forEach((data) => {
          if (data.PayStatus_Name) {
            statusCounts[data.PayStatus_Name] =
              (statusCounts[data.PayStatus_Name] || 0) + 1;
          }
        });

        setCountWaitPay(statusCounts["รอจ่าย"]);
        setCountPaid(statusCounts["จ่ายแล้ว"]);
        setCountCancel(statusCounts["ยกเลิก"]);
        setCurrentPage(1);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  // filterItems จะกรองข้อมูลตามวันที่และคำค้นหา
  const filterItems = () => {
    let filtered = masterList;

    // กรองตามวันที่ก่อน
    const start = moment(startDate, "YYYY-MM-DD");
    const end = moment(endDate, "YYYY-MM-DD");

    filtered = filtered.filter((item) => {
      const itemDate =
        dateType === "1"
          ? moment(item.Pay_Date, "YYYY-MM-DD")
          : moment(item.Doc_DueDate, "YYYY-MM-DD");
      return itemDate.isBetween(start, end, null, "[]");
    });

    // กรองตาม searchTerm ต่อ
    if (searchTerm.trim() !== "") {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((value) => {
          if (typeof value === "string") {
            return value.toLowerCase().includes(lowercasedSearchTerm);
          } else if (typeof value === "number") {
            return value.toString().includes(searchTerm);
          }
          return false;
        })
      );
    }

    // ฟิลเตอร์ตามสถานะที่เลือก
    if (selectedStatus) {
      filtered = filtered.filter((item) => item.PayStatus_Name === selectedStatus);
    }

    setFilteredItems(filtered);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleStatusClick = (statusName) => {
    if (selectedStatus === statusName) {
      setSelectedStatus(null);
    } else {
      setSelectedStatus(statusName);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs
          page={name}
          items={[
            { name: "จัดซื้อสินค้า", url: "/purchase" },
            { name: name, url: "/payment-voucher" },
          ]}
        />
      </div>
      <div className="row" style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <div className="col-1">
          <center>
            <b>สถานะเอกสาร</b>
          </center>
          <br />
          {statusColours.map((statusObj, index) => {
            const { DocSetStaus_Name, DocSetColour } = statusObj;
            let count;

            switch (DocSetStaus_Name) {
              case "รอจ่าย":
                count = countWaitPay;
                break;
              case "จ่ายแล้ว":
                count = countPaid;
                break;
              case "ยกเลิก":
                count = countCancel;
                break;
              default:
                count = 0;
            }

            return (
              <div
                key={index}
                className="col-12 mb-3"
                onClick={() => handleStatusClick(DocSetStaus_Name)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card text-center"
                  style={{
                    backgroundColor: DocSetColour,
                    boxShadow: selectedStatus === DocSetStaus_Name ? "0 0 15px rgba(0,0,0,0.5)" : "none",
                    border: selectedStatus === DocSetStaus_Name ? "2px solid #333" : "none",
                    transform: selectedStatus === DocSetStaus_Name ? "scale(1.05)" : "scale(1)",
                    transition: "transform 0.15s, box-shadow 0.15s, border 0.15s",
                  }}
                >
                  <div className="card-body d-flex flex-column align-items-center text-white">
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "20px", textAlign: "center" }}>
                          {count}
                        </b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "16px", textAlign: "center" }}>
                          {DocSetStaus_Name}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-11">
          <div
            className="p-3 rounded-3 my-2 shadow-lg"
            style={{ backgroundColor: "#ffff" }}
          >
            <div className="row  mb-2">
              <div className="col-3">
                <div className="navbar-form nav-search">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="ค้นหาเอกสาร..."
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        localStorage.setItem("searchTerm", e.target.value);
                      }}
                    />
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-7 d-flex">
                <DateFilterTable
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  onClick={onPageInsert}
                  className="btn btn-warning text-white ms-2"
                  type="button"
                >
                  สร้าง{name} <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <DataTable
            currentItems={currentItems}
            onRowSelected={onRowSelected}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            dataMasterList={filteredItems}
            setDataMasterList={setFilteredItems}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            fieldMappings={{
              no: "Pay_No",
              typeName: "PO_DocTypeName",
              statusName: "PayStatus_Name",
              statusColor: "PayStatus_Colour",
              printedStatus: 'Printed_Status',
              payTypeName: "Pay_TypeName",
              date: "Pay_Date",
              apCode: "AP_Code",
              apName: "AP_Name",
              dueDate: "Doc_DueDate",
              netTotal: "Total_Pay_NetTotal",
              createdBy: "Created_By_Name",
              updatedBy: "Update_By_Name",
              File_Name: "File_Name",
              File_Name_Rec: "File_Name_Rec",
            }}
            getReport={(docNo) => {
              (async () => {
                try {
                  await getReport("pay", docNo);
                } catch (e) {
                  console.error(e);
                } finally {
                  await initialize();
                }
              })();
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Main;
